import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";

import Title03Text from "../../../../../components/components-text/title-03-text";
import MainButton from "../../../../../components/main-button";
import MainTable from "../../../../../components/main-table";
import HealthCampaingItem from "../../../../../components/health-campaign-item/health-campaign-item";
import HealthCampaignItem from "../../../../../components/health-campaign-item-result/health-campaign-item-result";
import HealthInsuredItem from "../../../../../components/health-insured-item/health-insured-item";
import LeftInfoModal from "../../../../../components/left-info-modal";
import { images } from "../../../../../assets";
import { PriceDataContainer } from "./price-data-style";
import { ErrorModalContainer } from "../../../../../components/error-modal/error-modal-style";

import { SIGN_HIRING_STATUS_TYPE } from "../../../../../constants/hiring";
import { DEFAULT_PAY_METHOD } from "../../../../../constants/payTypes";
import { ICampanyas, IPricesMethod } from "../../../../../constants/health";
import { withCoverages } from "../../../../../context/mixin/with-coverages";
import { withGeneral } from "../../../../../context/mixin/with-general";
import { withPolicy } from "../../../../../context/mixin/with-policy";
import { withPayTypes } from "../../../../../context/mixin/with-pay-types";

import CampaignsServices from "../../../../../services/CampaignsServices";
import SaludPymesServices from "../../../../../services/SaludPymesServices";
import PayTypesServices from "../../../../../services/PayTypesServices";
import { getDefaultPriceResponse, getPaymentTableColumns } from "./price-data-helpers";
import { SaludPymesHireMenuHelper } from "../../../../../components/salud-pymes-hire-menu";
import { Steps } from "../../../../../components/salud-pymes-hire-menu/salud-pymes-hire-menu-types";
import { deepGet, formatter } from "../../../../../utils/utility";

import { ICoveragesQuoteAmount } from "../../../../simulations/new-simulation/result/interfaces/result-interface";
import {
  Campaign,
  ImportesAseguradoGarantiaBodyResponse,
  IPaymentTableRows,
  PriceProps,
  PriceState,
} from "./price-data-types";
import Loader from "../../../../../components/loader";

class PriceDataLayout extends React.Component<PriceProps, PriceState> {
  constructor(props: any) {
    super(props);

    this.state = {
      selectablePrices: [],
      selectedPrice: {
        paymentTime:
          props.data.taker && props.data.taker.policy && props.data.taker.policy.paymentType
            ? PayTypesServices.getPayTypeByCode(
                props.allPayTypes,
                props.data.taker.policy.paymentType,
              ).description
            : DEFAULT_PAY_METHOD.description,
        payType:
          props.data.taker && props.data.taker.policy && props.data.taker.policy.paymentType
            ? props.data.taker.policy.paymentType
            : DEFAULT_PAY_METHOD.code,
        price: "",
        taxes: "",
        total: "",
      },
      secondReceipsPrice: [],
      selectedCampaigns: [],
      selectableCampaigns: [],
      canContinue: true,
      modalErrorShow: false,
      modalErrorText: "",
      insuredData:
        this.props.data.insureds && this.props.data.insureds.length > 0
          ? this.props.data.insureds
          : [],
      pricesResponse: getDefaultPriceResponse(),
      paymentTableColumns: getPaymentTableColumns(),
      paymentTableRows: [],
      healthCoverages: [],
      modality: "",
      cancelSignModalShow: false,
      valueNewSignData: {
        code: "",
        name: "",
        selected: false,
        fromAPI: false,
      },
      isLoading: false,
    };
  }

  async componentDidMount() {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 100);

    const { policy } = this.props;
    if (Object.keys(policy.product).length !== 0) {
      await this.setInitialData();
    }
  }

  async componentDidUpdate(prevProps: PriceProps) {
    const { policy } = this.props;
    if (
      Object.keys(prevProps.policy.product).length === 0 &&
      Object.keys(policy.product).length !== 0
    ) {
      await this.setInitialData();
    }
  }

  formatData(data: any) {
    const { selectedCampaigns } = this.state;
    const campanyas: ICampanyas[] = selectedCampaigns.map((campanya) => ({
      CAMPANYA: campanya.code,
    }));
    const request: IPricesMethod = {
      COTIZACION: data.idcotiza,
      CAMPANYAS: campanyas.filter(
        (value, index, self) => index === self.findIndex((t) => t.CAMPANYA === value.CAMPANYA),
      ),
    };
    return request;
  }

  getPrices = async () => {
    const { setLoading, data, productPayTypes } = this.props;
    let { selectedPrice, selectablePrices, secondReceipsPrice, selectableCampaigns } = this.state;

    const priceRequest: IPricesMethod = this.formatData(data);

    let resPrices = await SaludPymesServices.getPrices({
      setLoading,
      data: priceRequest,
      loader: true,
    }).catch((error) => {
      this.setState({
        canContinue: false,
        modalErrorShow: true,
        modalErrorText: error,
      });
    });

    if (resPrices !== undefined) {
      //Seleccionar las campañas que devuelve la api
      resPrices.body.RESPUESTA.CAMPANYAS &&
        resPrices.body.RESPUESTA.CAMPANYAS.forEach((campanya) => {
          let name = selectableCampaigns.find((campaign) => campaign.code === campanya.CAMPANYA);
          if (name) this.handleSelectedCampaignsChange(campanya.CAMPANYA, name.name, false, true);
        });

      selectablePrices = [];
      secondReceipsPrice = [];

      resPrices.body.RESPUESTA.RECIBOS.forEach((importePago) => {
        if (importePago.INRECIBO === "S") {
          selectablePrices.push({
            payType: importePago.PERIODO_COBRO,
            price: importePago.PRIMANETA,
            taxes: importePago.TOTAL_IMPUESTOS,
            total: importePago.PRIMATOTAL,
          });
        } else {
          secondReceipsPrice.push({
            payType: importePago.PERIODO_COBRO,
            price: importePago.PRIMANETA,
            taxes: importePago.TOTAL_IMPUESTOS,
            total: importePago.PRIMATOTAL,
          });
        }
      });

      let selected = selectablePrices.filter(
        (selectablePrice) => selectablePrice.payType === selectedPrice.payType,
      )[0];

      let prices: IPaymentTableRows[] = [];
      selectablePrices.forEach((price, index) => {
        const newItem = {
          periodicity: {
            text: PayTypesServices.getPayTypeByCode(productPayTypes, price.payType).description,
            type: "",
            key: `radio`,
            selected: price.payType === selected.payType,
          },
          firstReceipt: {
            text: formatter.format(Number(price.total)),
            type: "",
            link: "",
            key: `float-right-cell`,
          },
          sequential: {
            text: secondReceipsPrice[index]
              ? formatter.format(Number(secondReceipsPrice[index].total))
              : formatter.format(0.0),
            type: "",
            link: "",
            key: `float-right-cell`,
          },
        };
        prices.push(newItem);
      });

      this.setState({
        selectedPrice: {
          ...selected,
          paymentTime: PayTypesServices.getPayTypeByCode(productPayTypes, selected.payType)
            .description,
        },
        selectablePrices,
        secondReceipsPrice,
        paymentTableRows: prices,
        pricesResponse: resPrices,
      });
    }

    return selectablePrices;
  };

  getCampaigns = async () => {
    const { setLoading, policy, data } = this.props;
    if (
      policy &&
      policy.product &&
      policy.product.products_colectivo &&
      policy.product.products_combinacion_comercial
    ) {
      let allCampaigns: Campaign[] = await CampaignsServices.getCampaigns({
        loader: true,
        setLoading,
        colective: policy.product.products_colectivo,
        combinacion_comercial: policy.product.products_combinacion_comercial,
        fecha_inicio: this.checkPolicyStartDate(data),
      })
        .then((data) => {
          return data;
        })
        .catch((e: any) => {
          throw e;
        });

      return allCampaigns;
    } else {
      this.setState({
        modalErrorShow: true,
        modalErrorText: "Se ha producido un error al obtener las campañas.",
      });
      return [];
    }
  };

  checkPolicyStartDate(data: any): string {
    if (
      data &&
      data.taker &&
      data.taker.policy &&
      data.taker.policy &&
      data.taker.policy.startDate
    ) {
      return data.taker.policy.startDate;
    }
    return new Date().toISOString();
  }

  async setInitialData() {
    const { policy, coverages } = this.props;

    const productDescription = await this.setProductDescription();

    if (productDescription) {
      let healthCoverages: any;
      if (coverages[policy.product.products_coverageName]) {
        healthCoverages = coverages[policy.product.products_coverageName];
      } else {
        healthCoverages = await SaludPymesServices.getCoveragesFromDB(
          this.props.setLoading,
          false,
          policy.product.products_coverageName,
        );
      }
      this.setState({ healthCoverages }, () => this.loadData());
    }
  }

  async setProductDescription() {
    const { policy } = this.props;

    let productDescription;
    if (Object.keys(policy.product).length !== 0) {
      productDescription = policy.product.products_name.toUpperCase();
      this.setState({ modality: productDescription });
    }
    return productDescription;
  }

  setPriceAndCampaigns() {
    const { data } = this.props;
    const selectedPrice = {
      paymentTime: data.priceData.price.paymentTime,
      payType: data.priceData.price.payType,
      price: data.priceData.price.price,
      discount: data.priceData.price.discount,
      taxes: data.priceData.price.taxes,
      total: data.priceData.price.total,
    };
    const selectedCampaigns = data.priceData.campaigns;
    this.setState({ selectedPrice, selectedCampaigns });
  }

  loadData = async () => {
    const campaigns = await this.getCampaigns();
    let { selectedCampaigns } = this.state;
    let selectedCampaignsChecked = campaigns.filter((campaign: Campaign) => campaign.isRequired);

    if (selectedCampaigns && selectedCampaigns.length > 0) {
      selectedCampaigns.forEach((campaign) => {
        let campaingToPush = campaigns.find((campaignRes) => campaignRes.code === campaign.code);
        if (campaingToPush) {
          const code = campaingToPush.code;
          // si no tiene la campaña seleccionada la agregamos
          if (!selectedCampaigns.some((c: any) => c.code === code))
            selectedCampaignsChecked.push(campaingToPush);
        }
      });
    }
    this.setState(
      { selectableCampaigns: campaigns, selectedCampaigns: selectedCampaignsChecked },
      async () => {
        let prices = await this.getPrices();
        this.setState({ selectablePrices: prices });
      },
    );
  };

  handlePriceRadioChange(
    time: string,
    payType: string,
    price: string,
    discount: string,
    taxes: string,
    total: string,
  ) {
    const value = {
      paymentTime: time,
      payType,
      price,
      discount,
      taxes,
      total,
    };
    this.setState({ selectedPrice: value });
  }

  async handleSelectedCampaignsChange(
    code: string,
    name: string,
    selected: boolean,
    fromAPI: boolean = false,
  ) {
    if (
      this.props.data &&
      this.props.data.signData &&
      this.props.data.signData.signStatus === SIGN_HIRING_STATUS_TYPE.REQUESTED
    ) {
      this.setState({
        cancelSignModalShow: true,
        valueNewSignData: { code: code, name: name, selected: selected, fromAPI: fromAPI },
      });
    } else {
      await this.getSelectedCampaigns(code, name, selected, fromAPI);
    }
  }

  async getSelectedCampaigns(
    code: string,
    name: string,
    selected: boolean,
    fromAPI: boolean = false,
  ) {
    const { selectedCampaigns } = this.state;
    if (selected) {
      if (selectedCampaigns.some((campaign) => campaign["code"] === code)) {
        const index = selectedCampaigns.findIndex((campaign) => campaign.code === code);
        selectedCampaigns.splice(index, 1);
      }
    } else {
      if (!selectedCampaigns.some((campaign) => campaign["code"] === code))
        selectedCampaigns.push({ code, name });
    }
    this.setState({ selectedCampaigns });
    if (!fromAPI) {
      let prices = await this.getPrices();
      this.setState({ selectablePrices: prices });
    }
  }

  savePriceData() {
    const { selectedCampaigns, selectedPrice, pricesResponse } = this.state;

    if (this.props.isReadOnly) return this.props.newStep();

    if (selectedPrice.price === "") {
      this.setState({
        modalErrorShow: true,
        modalErrorText:
          "Se ha producido un error durante el proceso de contratación, por favor inténtelo de nuevo más tarde.",
      });
      return;
    }

    const priceData = {
      price: selectedPrice,
      campaigns: selectedCampaigns,
      priceResponse: pricesResponse,
    };

    this.props.policy.setHealthData(priceData);
    this.props.saveHiring();
    this.props.newStep();
  }

  getUniqueListBy = (arr: any, key: any) => {
    return [...new Map(arr.map((item: any) => [item[key], item])).values()];
  };

  getDescriptionCoverage = (codeCoverage: string) => {
    const { insuredData } = this.state;
    let arrayCoverage: any = [];

    insuredData.map((x) => {
      Array.prototype.push.apply(arrayCoverage, x.coverages);
    });
    if (arrayCoverage) {
      arrayCoverage = this.getUniqueListBy(arrayCoverage, "code");
    }

    const coverage = arrayCoverage.filter((cov: any) => cov.code === codeCoverage);

    return coverage.length > 0 ? coverage[0].description : "";
  };

  getCoveragesQuoteAmount = (
    response: any,
    payType: string,
    codeCoverage: string,
    isFormat: boolean = true,
    numRiesgo: number = 0,
  ): ICoveragesQuoteAmount => {
    const coverageQuoteAmount = response.IMPORTES_ASEGURADO_GARANTIA.filter(
      (cov: any) => cov.PERIODO_COBRO === payType && cov.GARANTIA === codeCoverage,
    );
    if (!coverageQuoteAmount) {
      return { PRIMANETA: "", PRIMATOTAL: "", TOTAL_IMPUESTOS: "" };
    }
    let coverage: any = {};
    if (numRiesgo > 0) {
      coverage = coverageQuoteAmount.find((cov: any) => {
        return Number(cov.NUMERO_DE_RIESGO.toString()) === numRiesgo;
      });
    } else {
      coverage = coverageQuoteAmount[0];
    }
    return {
      PRIMATOTAL: isFormat ? formatter.format(Number(coverage.PRIMATOTAL)) : coverage.PRIMATOTAL,
      PRIMANETA: isFormat ? formatter.format(Number(coverage.PRIMANETA)) : coverage.PRIMANETA,
      TOTAL_IMPUESTOS: isFormat
        ? formatter.format(Number(coverage.TOTAL_IMPUESTOS))
        : coverage.TOTAL_IMPUESTOS,
      PERIODO_COBRO: coverage.PERIODO_COBRO,
    };
  };

  getCoverages(coverages: ImportesAseguradoGarantiaBodyResponse[]) {
    const coveragesAmount = coverages
      .filter(
        (cov: ImportesAseguradoGarantiaBodyResponse) =>
          cov.PERIODO_COBRO === this.state.selectedPrice.payType,
      )
      .map((cov: ImportesAseguradoGarantiaBodyResponse) => ({
        CODE: cov.GARANTIA,
        key: "dimmed-mini-body",
        CAPITAL:
          Number(cov.PRIMATOTAL) === 1 ? "Incluido" : formatter.format(Number(cov.PRIMATOTAL)),
        NUMERO_DE_RIESGO: Number(cov.NUMERO_DE_RIESGO),
        DESCRIPTION: this.getDescriptionCoverage(cov.GARANTIA),
        ...this.getCoveragesQuoteAmount(
          this.state.pricesResponse.body.RESPUESTA,
          this.state.selectedPrice.payType,
          cov.GARANTIA,
          true,
          Number(cov.NUMERO_DE_RIESGO),
        ),
      }));
    return coveragesAmount;
  }

  getPremiumConceptsAndInformativeConcepts() {
    const { pricesResponse, selectedPrice } = this.state;
    let totalPremiumConcepts: any = [];
    let informativeCoverageConcepts: any = [];
    const totalPremiumConceptsList = [
      "CONSORCIO",
      "DGS",
      "GARANTIA",
      "IPS",
      "PRIMANETA",
      "RECARGOFRA",
    ];

    const informativeCoverageConceptsLit = [
      "GARANTIA",
      "PRIMAPURA",
      "SOBREPRIMA",
      "EXTRAPRIMA",
      "GASTOSINT",
      "GASTOSEXT",
      "GASTOSEMI",
      "DEDUCCIONES",
      "RECARGOCONS",
      "RECARGOBEN",
      "DESCUENTOFP",
      "CAMPANYAS",
      "DESCUENTOS",
    ];

    pricesResponse.body.RESPUESTA.IMPORTES_COTIZACION_GARANTIA.filter(
      (price) => price.PERIODO_COBRO === selectedPrice.payType,
    ).forEach((item: any, index: number) => {
      let newPremiumConcepts: any = {};
      let newInformativeConcepts: any = {};

      Object.entries(item).forEach(([key, value]) => {
        if (totalPremiumConceptsList.includes(key)) {
          newPremiumConcepts[key] = value;
        }
        if (informativeCoverageConceptsLit.includes(key)) {
          newInformativeConcepts[key] = value;
        }
      });
      totalPremiumConcepts.push(newPremiumConcepts);
      informativeCoverageConcepts.push(newInformativeConcepts);
    });

    return { totalPremiumConcepts, informativeCoverageConcepts };
  }

  getFormatedDiscount = () => {
    const insuredCountDiscount: string = deepGet(this.state.pricesResponse.body, "RESPUESTA.DESCUENTO_ASEGURADO_PYMES.0.VALOR_DESCUENTO", "") || "";
    if (!insuredCountDiscount) {
      return "";
    }

    const trimmedDiscount = insuredCountDiscount.trim();
    if (!trimmedDiscount) {
      return "";
    }
    
    const discountNum = trimmedDiscount.replace(',', '.');
    const formatedNum = parseFloat(discountNum);
    if (isNaN(formatedNum) || !isFinite(formatedNum) || formatedNum <= 0) return "";

    return `${formatedNum}%`;
  }

  render() {
    const {
      selectedCampaigns,
      selectableCampaigns,
      paymentTableColumns,
      paymentTableRows,
      pricesResponse,
      selectedPrice,
      healthCoverages,
      modality,
      canContinue,
      cancelSignModalShow,
      valueNewSignData,
      isLoading,
    } = this.state;
    const { isReadOnly, data } = this.props;

    const coveragesAmount = this.getCoverages(
      pricesResponse.body.RESPUESTA.IMPORTES_ASEGURADO_GARANTIA,
    );

    const insuredCountDiscount = this.getFormatedDiscount();

    return (
      <PriceDataContainer>
        {isLoading && <Loader />}
        <div className="data-flow-status">
          <div className="data-flow-status-title">
            <h2>{"DATOS DEL SEGURO"}</h2>
          </div>
        </div>

        <div className="result-simulation-container">
          <div className="result-simulation-item float">
            <div className="result-simulation-special-title">
              <Title03Text>
                <p>Modalidad</p>
              </Title03Text>
            </div>
            <div className="result-simulation-item-content">
              {pricesResponse.body.RESPUESTA.IMPORTES_COTIZACION_GARANTIA.filter(
                (coverage) => coverage.PERIODO_COBRO === selectedPrice.payType,
              ).length > 0 && (
                <HealthCampaignItem
                  checked={false}
                  index={1}
                  onCheckInsured={() => {}}
                  coverages={pricesResponse.body.RESPUESTA.COBERTURAS}
                  coveragesPriceAmount={pricesResponse.body.RESPUESTA.IMPORTES_COTIZACION_GARANTIA.filter(
                    (coverage) => coverage.PERIODO_COBRO === selectedPrice.payType,
                  )}
                  totalPremiumConcepts={
                    this.getPremiumConceptsAndInformativeConcepts().totalPremiumConcepts
                  }
                  informativeCoverageConcepts={
                    this.getPremiumConceptsAndInformativeConcepts().informativeCoverageConcepts
                  }
                  totalPrice={
                    pricesResponse.body.RESPUESTA.IMPORTESFORPAGO.filter(
                      (price) => price.PERIODO_COBRO === selectedPrice.payType,
                    ).length > 0
                      ? pricesResponse.body.RESPUESTA.IMPORTESFORPAGO.filter(
                          (price) => price.PERIODO_COBRO === selectedPrice.payType,
                        )[0].PRIMATOTAL
                      : ""
                  }
                  healthCoverages={healthCoverages}
                  modalityName={modality}
                  payType={(selectedPrice && selectedPrice.payType) || ""}
                  insuredCountDiscount={insuredCountDiscount}
                />
              )}
            </div>
          </div>
          <div className="result-simulation-item float">
            <div className="result-simulation-item-title">
              <Title03Text>
                <p>Desglose por forma de pago</p>
              </Title03Text>
            </div>
            <div className="colSin-100">
              <div className="result-simulation-item-content">
                <div className="result-simulation-item-content-table">
                  <MainTable
                    className="table noZebra"
                    columns={paymentTableColumns}
                    rows={paymentTableRows}
                    keysRow={["periodicity", "firstReceipt", "sequential"]}
                    keysAlignRight={["firstReceipt", "sequential"]}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="result-simulation-item float">
            <div className="result-simulation-item-title">
              <Title03Text>
                <p>Miembros de la póliza</p>
              </Title03Text>
            </div>
            <div className="result-simulation-item-content-table">
              <div className="tabs">
                {data.insureds.map((insured: any, index: number) => {
                  return (
                    <HealthInsuredItem
                      age={Math.floor(
                        moment().diff(moment(insured.birthDate, "DD/MM/YYYY", true), "years", true),
                      )}
                      birthDate={insured.birthDate}
                      gender={insured.gender}
                      checked={false}
                      coverages={insured.coverages}
                      id={data.insureds.length - index}
                      index={index + 1}
                      key={index}
                      onChange={() => "this.handleRemoveInsured(index)"}
                      onClick={() => "this.handleRemoveInsured(index)"}
                      onCheckInsured={() => "this.handleInsuredCheck(insured)"}
                      result={true}
                      isPrices={true}
                      coverageAmount={coveragesAmount.filter(
                        (cov: any) => Number(cov.NUMERO_DE_RIESGO) === index + 1,
                      )}
                      insured={insured}
                      healthCoverages={healthCoverages}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="content-wrapper bottomMargin20">
          {selectableCampaigns.map((b, index) => (
            <HealthCampaingItem
              disabled={b.isRequired || isReadOnly}
              campaignName={b.name}
              campaignDescription={b.description}
              campaignCode={b.code}
              defaultChecked={
                b.isRequired || selectedCampaigns.some((campaign) => campaign["code"] === b.code)
              }
              onClick={(campaignCode: string, campaignName: string, selected: boolean) =>
                this.props.isReadOnly
                  ? true
                  : this.handleSelectedCampaignsChange(campaignCode, campaignName, selected)
              }
            />
          ))}
        </div>

        <div className="colSin-100 topMargin20 bottomMargin20">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                text="Atrás"
                onClick={() =>
                  this.props.data.taker.physicalPerson
                    ? this.props.history.push(
                        SaludPymesHireMenuHelper.getPreviousStepNavigationPath(Steps.Prima),
                      )
                    : this.props.history.push(
                        SaludPymesHireMenuHelper.getPreviousStepNavigationPath(Steps.Prima - 1),
                      )
                }
              />
            </div>
            <div className="personal-data-buttons__item">
              <MainButton
                disabled={!canContinue}
                withTab={true}
                text="Siguiente"
                onClick={() => this.savePriceData()}
              />
            </div>
          </div>
        </div>
        <LeftInfoModal
          img={images.IconWarningYellow}
          className="error"
          mainTitle={"¿Seguro que desea continuar?"}
          mainText={"Se cancelará la firma previamente solicitada"}
          buttonText="Continuar"
          closeButtonText="Cancelar"
          close={() => this.setState({ cancelSignModalShow: false })}
          active={cancelSignModalShow}
          onClickAccept={() => {
            this.setState({ cancelSignModalShow: false }, () =>
              this.getSelectedCampaigns(
                valueNewSignData.code,
                valueNewSignData.name,
                valueNewSignData.selected,
                valueNewSignData.fromAPI,
              ),
            );
          }}
        />
        <ErrorModalContainer className={`${this.state.modalErrorShow && `active`}`}>
          <div className="recover-modal">
            <div className="server-error">
              <p>{this.state.modalErrorText}</p>
            </div>
            <div className="button-error">
              <MainButton
                text="Aceptar"
                onClick={() => this.setState({ modalErrorShow: false, modalErrorText: "" })}
              />
            </div>
          </div>
        </ErrorModalContainer>
      </PriceDataContainer>
    );
  }
}

export default withGeneral(withCoverages(withPayTypes(withPolicy(withRouter(PriceDataLayout)))));
